module.exports = __webpack_public_path__ + "img/close_no_border.d955a84b.svg";